import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import type { To } from 'react-router'

import { NavTabs } from '#design-system/component/NavTabs/NavTabs'
import { Chat } from '#design-system/icons/chat'
import { House } from '#design-system/icons/house'
import { Tray } from '#design-system/icons/tray'

interface PrimaryNavProps {
  notificationCount?: number | undefined
  onNavigate: (to: string) => void
}

const toPath = (to: To): string => (typeof to === 'string' ? to : (to.pathname ?? ''))

/** Primary mode switcher (Inbox / Chats / Home).
 * `onNavigate` resumes each section's last-visited route rather than its root (handled by the Nav container). */
export const ModeSwitcher = ({ notificationCount, onNavigate }: PrimaryNavProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <NavTabs
      aria-label={t('shell.nav.modes')}
      items={[
        { count: notificationCount, icon: <Tray />, label: t('shell.nav.inbox'), to: '/inbox' },
        { icon: <Chat />, label: t('shell.nav.chats'), to: '/chats' },
        { icon: <House />, label: t('shell.nav.home'), to: '/home' },
      ]}
      onNavigate={(to) => {
        onNavigate(toPath(to))
      }}
      orientation="vertical"
    />
  )
}
